import {
  Button,
  TextField,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Container,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { GroupAdd, ListAltOutlined } from "@material-ui/icons";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import DescriptionIcon from "@material-ui/icons/Description";
import { PDIRMenus,PDIRSupplierMenus,IQCMenues } from "../../Utilities/Utility";
import { useSelector } from "react-redux";
import "./pdir.scss";

export default function WelcomePDIR() {
  const userDetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
  const icons = {
    "<ListAltOutlined />": <ListAltOutlined />,

    "<DescriptionIcon />": <DescriptionIcon />,

    "<GroupAdd />": <GroupAdd />,
  };
  return (
    <>
      <div className="main-component1" style={{ padding: "5px", border: "1px solid grey;" }}>
        <h2 style={{color:"white"}}>Welcome to Inspection Tracker</h2>

     


           <Grid container className="Complaints-block" spacing={2}>

           
                  {userDetails.roleId === 3 ? PDIRSupplierMenus.map((item, index) => (
                      <Grid item xs={12} sm={4} key={index}>
                          <Link
                              to={item.menuLink}
                              className="animated-menu-link"
                          >
                              <div className="tool-banner">
                                  <div className="icon-box">
                                      {item.complaintIcon ? (
                                          item.complaintIcon
                                      ) : (
                                          <div>No Icon</div>
                                      )}
                                  </div>
                                  <div className="green-bar">
                                      <span className="menu-label">
                                          {item.menuName}
                                      </span>
                                  </div>
                              </div>
                          </Link>
                      </Grid>
                  )) : userDetails.roleId === 12 ?IQCMenues.map((item, index) => (
                      <Grid item xs={12} sm={4} key={index}>
                          <Link
                              to={item.menuLink}
                              className="animated-menu-link"
                          >
                              <div className="tool-banner">
                                  <div className="icon-box">
                                      {item.complaintIcon ? (
                                          item.complaintIcon
                                      ) : (
                                          <div>No Icon</div>
                                      )}
                                  </div>
                                  <div className="green-bar">
                                      <span className="menu-label">
                                          {item.menuName}
                                      </span>
                                  </div>
                              </div>
                          </Link>
                      </Grid>
                  )) :
                          PDIRMenus.map((item, index) => (
                              <Grid item xs={12} sm={4} key={index}>
                                  <Link
                                      to={item.menuLink}
                                      className="animated-menu-link"
                                  >
                                      <div className="tool-banner">
                                          <div className="icon-box">
                                              {item.complaintIcon ? (
                                                  item.complaintIcon
                                              ) : (
                                                  <div>No Icon</div>
                                              )}
                                          </div>
                                          <div className="green-bar">
                                              <span className="menu-label">
                                                  {item.menuName}
                                              </span>
                                          </div>
                                      </div>
                                  </Link>
                              </Grid>
                          )) }
                </Grid>
      </div>
    </>
  );
}
